export default __webpack_public_path__ + "static/media/TSImg.c00ebb15.png";